// Точка входа нового фронта (п.20). Старая оболочка index.html подключает
// /web/plot-web.js и вызывает window.PlotWeb.mount('spiski', el, ctx) при открытии
// вкладки; экраны переезжают по одному, оболочка остаётся.
import { createRoot, type Root } from 'react-dom/client';
import { Pivot } from './screens/Pivot';
import { Plan } from './screens/Plan';
import { Spiski } from './screens/Spiski';
import { Struct } from './screens/Struct';
import { Users } from './screens/Users';
import { Gant } from './screens/Gant';
import { Links } from './screens/Links';
import { Works } from './screens/Works';
import { Podryad } from './screens/Podryad';
import { Fakt } from './screens/Fakt';
import { FaktLog } from './screens/FaktLog';
import { Kvart } from './screens/Kvart';
import { Resurs } from './screens/Resurs';
import { Rep } from './screens/Rep';
import { Checks } from './screens/Checks';
import { Ruch } from './screens/Ruch';
import { Wiki } from './screens/Wiki';
import { Model } from './screens/Model';
import { Filters } from './screens/Filters';
import { App } from './App';
import { filterStore } from './filter';
import type { ShellCtx } from './shell';
import './tokens.css';
import './app.css';

const SCREENS: Record<string, (ctx: ShellCtx) => JSX.Element> = {
  spiski: (ctx) => <Spiski ctx={ctx} />,
  plan: (ctx) => <Plan ctx={ctx} />,
  gant: (ctx) => <Gant ctx={ctx} />,
  pivot: (ctx) => <Pivot ctx={ctx} />,
  struct: (ctx) => <Struct ctx={ctx} />,
  works: (ctx) => <Works ctx={ctx} />,
  podryad: (ctx) => <Podryad ctx={ctx} />,
  links: (ctx) => <Links ctx={ctx} />,
  users: (ctx) => <Users ctx={ctx} />,
  fakt: (ctx) => <Fakt ctx={ctx} />,
  faktlog: (ctx) => <FaktLog ctx={ctx} />,
  kvart: (ctx) => <Kvart ctx={ctx} />,
  resurs: (ctx) => <Resurs ctx={ctx} />,
  rep: (ctx) => <Rep ctx={ctx} />,
  checks: (ctx) => <Checks ctx={ctx} />,
  ruch: (ctx) => <Ruch ctx={ctx} />,
  wiki: () => <Wiki />,
  model: (ctx) => <Model ctx={ctx} />,
  filters: (ctx) => <Filters ctx={ctx} />,
};
const roots = new WeakMap<Element, Root>();

const PlotWeb = {
  version: '2.0.0',
  /** доступ оболочки к фильтру: выбрать корпус (переходы из «Проверок») */
  filter: filterStore,
  screens: Object.keys(SCREENS),
  mount(screen: string, el: Element, ctx: ShellCtx): boolean {
    const make = SCREENS[screen];
    if (!make) return false;
    let root = roots.get(el);
    if (!root) { root = createRoot(el); roots.set(el, root); }
    root.render(make(ctx));
    return true;
  },
  unmount(el: Element) {
    const root = roots.get(el);
    if (root) { root.unmount(); roots.delete(el); }
  },
};

declare global { interface Window { PlotWeb?: typeof PlotWeb } }
window.PlotWeb = PlotWeb;
// Бандл — модуль, он выполняется ПОСЛЕ обычных скриптов оболочки, поэтому на
// старте её кода PlotWeb ещё нет. Сообщаем о готовности — оболочка тогда
// монтирует панель фильтров и текущий экран (ошибка 2026-09-07: панель пропала).
// Приложение целиком (финал переезда): если на странице есть #plotRoot —
// рисуем вход, меню и экраны сами; старая оболочка тогда не нужна.
const rootEl = document.getElementById('plotRoot');
if (rootEl) createRoot(rootEl).render(<App />);
window.dispatchEvent(new Event('plotweb-ready'));
export default PlotWeb;
